import { URL_LABEL } from "../../../index.content";

const feesCalculatorForAmazonFBA = ({ language, isSavedUser }) => {
  return {
    title: "Fees Calculator for Amazon FBA",
    url: isSavedUser
      ? "https://chrome.google.com/webstore/detail/amazon-fba-calculator-fre/dkgjopcolgcafhnicdahjemapkniikeh?utm_source=site&utm_medium=amzscout&utm_campaign=footer"
      : `/fba-fee-calculator/?${URL_LABEL}`,
    target: isSavedUser,
    ref: false,
    isLink: !isSavedUser,
  };
};

export default feesCalculatorForAmazonFBA;
